import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { LandingNavItemComponent } from "./landing-nav-item/landing-nav-item.component";
import { LandingNavItem } from "./landing-nav-item/landing-nav-item.model";
import { boostThemeEnum } from "@app/services/page.service";
import { LandingScoreComponent } from "./landing-score/landing-score.component";
import { LandingPlanComponent } from "./landing-plan/landing-plan.component";

/**
 * Component that displays the main navigation menu on the landing page.
 * Contains a collection of themed navigation cards for different app features:
 * - Scoring (beautyberry theme)
 * - Planning (glacier theme)
 * - Learning Platform (riverbed theme)
 * - Chat/Support (forest path theme)
 */
@Component({
  selector: "app-landing-navigation",
  templateUrl: "./landing-navigation.component.html",
  styleUrls: ["./landing-navigation.component.scss"],
  standalone: true,
  imports: [CommonModule, MatButtonModule, LandingNavItemComponent, LandingScoreComponent, LandingPlanComponent],
})
export class LandingNavigationComponent {
  /**
   * Array of navigation items displayed on the landing page.
   * Each item represents a major feature of the application with:
   * - Distinct theme and content styling
   * - Descriptive title and content
   * - Call-to-action button
   * - Router link (except for chat which may open externally)
   */
  navigationItems: LandingNavItem[] = [
    // {
    //   theme: boostThemeEnum.beautyberry,
    //   contentTheme: "feelings",
    //   title: "It's time to Score",
    //   content:
    //     "Score your halos and zombies now so that you can assess today's Safety Buffer!",
    //   action: "SCORE NOW",
    //   routerLink: "/score",
    // },
    // {
    //   theme: boostThemeEnum.glacier,
    //   contentTheme: "starlight",
    //   title: "Make a Plan",
    //   content:
    //     "Plan your day's activities, making sure you play lots of safety cards to help you reach the end of the day with a strong Safety Buffer.",
    //   action: "PLAN NOW",
    //   routerLink: "/pace",
    // },
    {
      theme: boostThemeEnum.riverbed,
      contentTheme: "lupine",
      title: "Learning Platform",
      content:
        "Our flip* LEARN platform is the place to go to continue your pain recovery journey out-of-session. You can access all of your session slideshows here, as well as worksheets and lots of pain science eduction.",
      action: "OPEN LEARN",
      url: "https://brain-changer.thinkific.com/users/sign_in",
    },
    // {
    //   theme: boostThemeEnum.forestpath,
    //   contentTheme: "forest-path",
    //   title: "Have a question?",
    //   content:
    //     "You can check in with your Peer Mentor and Coach any time by using flip* chat.",
    //   action: "CHAT NOW",
    // },
  ];
}
